import React, { useCallback, useEffect, useState } from 'react';
import { ModalBody, ModalHeader } from 'reactstrap';
import Rodal from '../../../../components/Rodal/Rodal';
import { useStateSelector } from '../../../../store/selectors';
import { fetchLoiForm } from '../../../../slices/marketplace/loi-form/loi-forms-api';
import { LoiForm } from '../../../../slices/marketplace/loi-form/loi-form';
import { LoiAndTermsForm } from '../../../Admin/BuyerMarketplace/OpportunityDetails/LoiSubmissionPackage/LoiAndTermsForm/LoiAndTermsForm';
import createNotification from '../../../../utils/createNotification';
import Helpers from '../../../../utils/helper';

interface LoiSubmissionQuestionsPopupProps {
    loiFormId: string;
    onClose: () => void;
}

const LoiSubmissionQuestionsPopup = (props: LoiSubmissionQuestionsPopupProps) => {
    const axios = useStateSelector((state) => state.core.axios);
    const [formData, setFormData] = useState<LoiForm | null>(null);
    const [isLoading, setIsLoading] = useState(true);

    const loadForm = useCallback(async () => {
        setIsLoading(true);
        try {
            const data = await fetchLoiForm(axios, props.loiFormId);
            setFormData(data);
        } catch {
            createNotification('Could not load LOI form. Please try again.', 'error');
        } finally {
            setIsLoading(false);
        }
    }, [axios, props.loiFormId]);

    useEffect(() => {
        loadForm();
    }, [loadForm]);

    return (
        <Rodal
            visible={true}
            onClose={props.onClose}
            animation="slideUp"
            showMask={true}
            width={900}
            showCloseButton={true}
            customStyles={{ height: 'auto' }}>
            <ModalHeader>LOI Submission Questions</ModalHeader>
            <ModalBody style={{ maxHeight: '80vh', overflowY: 'auto' }}>
                {isLoading ? (
                    Helpers.renderTableLoader()
                ) : !formData ? (
                    <div className="text-danger">No LOI form data available.</div>
                ) : (
                    <LoiAndTermsForm
                        formData={formData}
                        isReadonly={true}
                        isInitialQuestionsReadonly={true}
                        isQuestionsOnly={true}
                        onChange={() => {}}
                        sellerLocations={formData.sellerLocations ?? []}
                    />
                )}
            </ModalBody>
        </Rodal>
    );
};

export default LoiSubmissionQuestionsPopup;
